import PaneContainer from '@/layouts/components/PaneContainer'
import SingleColumn from '@/layouts/SingleColumn'
import { Card } from 'primereact/card'
import { Steps } from 'primereact/steps'
import { Link } from '@tanstack/react-router'
import Loader from '../CreatePlan/steps/Loader'
import WeekSelector from './components/WeekSelector'
import ShiftAssignmentGrid from './components/ShiftAssignmentGrid'
import OptimizerResultView from './components/OptimizerResultView'
import { useDetailedPlanFlow } from './hooks/useDetailedPlanFlow'

const DetailedPlan = () => {
  const {
    stepIndex,
    steps,
    excelPlanResponse,
    selectedWeek,
    weekOptions,
    machineIds,
    staffList,
    assignments,
    optimizerResult,
    isOptimizing,
    goToStep,
    loadExcel,
    selectWeek,
    updateAssignment,
    updateMachineDayAssignments,
    hasPendingShiftChanges,
    optimizedAssignments,
    applyPreset,
    clearDateAssignments,
    runOptimizer,
    reloadAndReoptimize,
    excelReloadDialog,
    excelWriteDialog,
  } = useDetailedPlanFlow()

  return (
    <SingleColumn>
      <PaneContainer>
        <div className="tm-grid tm-grid-cols-1 gap-4 w-full tw-mx-2 mx-auto p-2">
          <div>
            <Link to="/dashboard">&lt; ダッシュボードに戻る</Link>
          </div>
          <h1 className="text-2xl font-medium mb-3">詳細生産計画</h1>
          <Card className="flex flex-column gap-4 w-full mx-auto">
            <Steps model={steps} activeIndex={stepIndex} className="mb-2" />
            {stepIndex === 0 && <Loader onLoad={loadExcel} />}
            {stepIndex === 1 && (
              <WeekSelector
                weeks={weekOptions}
                onSelect={selectWeek}
                onBack={() => goToStep(0)}
              />
            )}
            {stepIndex === 2 && selectedWeek && (
              <ShiftAssignmentGrid
                week={selectedWeek}
                machineIds={machineIds}
                staffList={staffList}
                assignments={assignments}
                productionTasks={excelPlanResponse?.echoProductionTasks ?? []}
                products={excelPlanResponse?.echoOrderProducts ?? []}
                onAssign={updateAssignment}
                onApplyPreset={applyPreset}
                onClearDate={clearDateAssignments}
                onBack={() => goToStep(1)}
                onRunOptimizer={runOptimizer}
                isOptimizing={isOptimizing}
              />
            )}
            {stepIndex === 3 && optimizerResult && selectedWeek && (
              <OptimizerResultView
                result={optimizerResult}
                week={selectedWeek}
                machineIds={machineIds}
                products={excelPlanResponse?.echoOrderProducts ?? []}
                orders={excelPlanResponse?.echoOrders ?? []}
                assignments={assignments}
                optimizedAssignments={optimizedAssignments}
                hasPendingShiftChanges={hasPendingShiftChanges}
                staffList={staffList}
                onBack={() => goToStep(2)}
                onReoptimize={runOptimizer}
                onUpdateMachineDayAssignments={updateMachineDayAssignments}
                excelReloadDialog={excelReloadDialog}
                excelWriteDialog={excelWriteDialog}
                isOptimizing={isOptimizing}
              />
            )}
          </Card>
        </div>
      </PaneContainer>
    </SingleColumn>
  )
}

export default DetailedPlan
